import { useSelector } from 'react-redux';

export const useAuth = (resource, id) => {
  return useSelector((state) => ({
    user: state?.auth?.user || null,
    profile: state?.auth?.user?.profile || {},
    isLoggedIn: state?.auth?.isLoggedIn || false,
    isLoggingIn: state?.auth?.isLoggingIn || false,
    loginRequired: state?.auth?.loginRequired || false,
    silentFailure: state?.auth?.silentFailure || false
  }));
}

/***
 * @deprecated use `useAuth` instead
 */
export const getAuthHook = useAuth;
